import { PT_CART, PT_ORDERSTATUS, PT_PAYMODE } from "./paths/pt-cart";
import { RTCart, RTPaymode, RTOrderStatus } from "../screens/sc-cart";
import { KEY_GENERATOR } from "../../functions/funtion";
import { Route } from "react-router-dom";

let RouteArray = [
  <Route key={KEY_GENERATOR()} path={PT_CART} element={<RTCart />} />,
  <Route key={KEY_GENERATOR()} path={PT_PAYMODE} element={<RTPaymode />} />,
  <Route
    key={KEY_GENERATOR()}
    path={PT_ORDERSTATUS}
    element={<RTOrderStatus />}
  />,
];

export default RouteArray;
